import React from 'react';
import { NavLink } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { isAdminOrAbove, isSSLOrAbove } from '../../utils/roles';

const NavItem = ({ to, label }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
        isActive
          ? 'bg-indigo-700 text-white'
          : 'text-indigo-100 hover:bg-indigo-700/50'
      }`
    }
  >
    {label}
  </NavLink>
);

export default function Sidebar({ open, onClose }) {
  const { user } = useAuth();

  return (
    <>
      {/* Mobile overlay */}
      {open && (
        <div
          className="fixed inset-0 z-20 bg-black/40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar panel */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-30 flex w-64 flex-col bg-indigo-800
          transform transition-transform duration-200 ease-in-out
          lg:relative lg:translate-x-0
          ${open ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        {/* Brand */}
        <div className="flex h-16 items-center gap-2 px-4 border-b border-indigo-700">
          <span className="text-xl font-bold text-white">RWeBe Scheduling</span>
        </div>

        {/* Nav links */}
        <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-4">
          <NavItem to="/dashboard"    label="Dashboard" />
          <NavItem to="/schedule"     label="Schedule" />
          <NavItem to="/availability" label="Availability" />
          <NavItem to="/swaps"        label="Swap Marketplace" />

          {isSSLOrAbove(user) && (
            <>
              <div className="mt-4 mb-1 px-3 text-xs font-semibold uppercase tracking-wider text-indigo-300">
                SSL
              </div>
              <NavItem to="/admin/periods"   label="Periods" />
              <NavItem to="/schedule/manage" label="Manage Schedule" />
              <NavItem to="/swaps/approvals" label="Swap Approvals" />
            </>
          )}

          {isAdminOrAbove(user) && (
            <>
              <div className="mt-4 mb-1 px-3 text-xs font-semibold uppercase tracking-wider text-indigo-300">
                Admin
              </div>
              <NavItem to="/admin/users"     label="Users" />
              <NavItem to="/admin/semesters" label="Semesters" />
              <NavItem to="/admin/district"  label="District Setup" />
            </>
          )}
        </nav>

        {/* User badge at bottom */}
        <div className="border-t border-indigo-700 px-4 py-3">
          <p className="text-sm font-medium text-white truncate">
            {user?.first_name} {user?.last_name}
          </p>
          <p className="text-xs text-indigo-300 truncate">{user?.role}</p>
        </div>
      </aside>
    </>
  );
}
